module.exports = __webpack_public_path__ + "img/bcm-need-mx.5e7529bf.jpg";